import { render, staticRenderFns } from "./RecruitingDetailDialog.vue?vue&type=template&id=2e8c5eaa&scoped=true&lang=pug&"
import script from "./RecruitingDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./RecruitingDetailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RecruitingDetailDialog.vue?vue&type=style&index=0&id=2e8c5eaa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8c5eaa",
  null
  
)

export default component.exports